import React, { useEffect } from "react";
import { setCurrentWizardData } from "../../../../redux/actions/wizardActions";
import { createCredObject } from "../../../../common/factory/credential.factory";
import { useDispatch, useSelector } from "react-redux";
import { CredentialsType } from "../../../../common/interfaces/credentials/Credentials";
import { saveCred } from "../../../../redux/actions/credActions";
import { clone } from "../../../../common/utils/helper";

/**
 * The useEffect will start the creation.
 * It creates the Basic Auth PAT for working with Assets
 * It sets the currentData.importCredentialsReferences.patTokenRefId You should listen to this property to know when to create the flow.
 *
 */
const SaveBasicAuth = ({ patTokenName }) => {
  const dispatch = useDispatch();
  const currentData = useSelector((state) => state.wizard.currentData);
  const workspace = useSelector((state) => state.jiraAssets.workspace);
  const token = useSelector((state) => state.jiraAssets.token);

  const importSource = useSelector((state) => state.jiraAssets.importSource);
  const selectedAssetSchema = useSelector(
    (state) => state.jiraAssets.selectedAssetSchema
  );
  const importSourceName = useSelector(
    (state) => state.jiraAssets.importSourceName
  );
  const saveWithNewBasicAuth = async (tokenObj) => {
    //run add basic auth
    const basic = createCredObject(patTokenName, CredentialsType.BASIC_AUTH);
    basic.data = {
      username: currentData.jiraUserEmail,
      password: currentData.jiraUserPassword,
    };
    const basicPromise = dispatch(saveCred(basic));
    Promise.all([basicPromise])
      .then((results) => {
        if (!currentData.importCredentialsReferences) {
          currentData.importCredentialsReferences = {
            patTokenRefId: results[0]?.id,
          };
        } else {
          currentData.importCredentialsReferences.patTokenRefId = results[0]?.id
        }
        dispatch(setCurrentWizardData(clone(currentData)));
      })
      .catch((error) => {
        console.error("Error saving credentials:", error);
      });
  };
  /**
   * We set this ref to have the same expirence when using the credential regardless of created new or choosing existing.
   */
  const addCredentialReference=()=>{
    if (!currentData.importCredentialsReferences) {
      currentData.importCredentialsReferences = {
        patTokenRefId: currentData.credential.value,
      };
    } else {
      currentData.importCredentialsReferences.patTokenRefId = currentData.credential.value
    }
    dispatch(setCurrentWizardData(clone(currentData)));
  }

  //init the create asset token and PAT token
  useEffect(() => {
    if (
      !currentData?.importCredentialsReferences &&
      workspace &&
      importSource &&
      selectedAssetSchema &&
      importSourceName &&
      token
    ) {
      //console.log("token",token)
      if (currentData.selectedAuthOption === "WizardBasicAuth") {
        saveWithNewBasicAuth();
      } else {
        addCredentialReference()
      }
    }
  }, [currentData, token]);
  return (<></>)
};

export default SaveBasicAuth;
